import { useTerminologyReplacer } from "@/hooks/useTerminologyReplacer";
import { TerminologyOptions } from "@/types/v2";

export interface CardBreadcrumbProps {
  shopId: string;
  cardId: string;
  cardNumber?: string | null;
}

export const useCardBreadcrumbs = ({
  shopId,
  cardId,
  cardNumber,
}: CardBreadcrumbProps) => {
  const { terminolize } = useTerminologyReplacer();

  return [
    { label: "Dashboard", href: `/${shopId}` },
    {
      label: terminolize(
        "Repair Orders",
        TerminologyOptions.repairOrder,
        "plural"
      ),
      href: `/${shopId}/cards`,
    },
    {
      label:
        cardNumber ||
        `${terminolize("Repair Order", TerminologyOptions.repairOrder, "singular")} ${cardId}`,
    },
  ];
};
